module.exports = __webpack_public_path__ + "img/20201107_094640.c9e47f59.jpg";